import {
  fetchAddLegalAgreement,
  TAddLegalAgreementRequest,
  TAddLegalAgreementResponse,
} from '../../repositories/users-features/v1/add-legal-agreement';
import { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';
import { ILogger } from '@cian/logger';
import { IHttpApi } from '@cian/http-api';

interface IContextParams {
  logger: ILogger;
  httpApi: IHttpApi;
}

export const resolveAddLegalAgreement = async (
  { httpApi, logger }: IContextParams,
  parameters: TAddLegalAgreementRequest,
): Promise<void> => {
  try {
    const response: TAddLegalAgreementResponse = await fetchAddLegalAgreement({
      httpApi,
      parameters,
    });

    if (response.statusCode === 200) {
      return;
    }

    logger.error(
      new HttpBadStatusCodeError({
        statusCode: response.statusCode,
        message: 'Ошибка при добавлении соглашения',
        domain: 'src/shared/services/addLegalAgreement/service.ts',
      }),
    );

    return;
  } catch (error) {
    logger.error(
      new UnknownError({
        message: 'Ошибка при добавлении соглашения',
        domain: 'src/shared/services/addLegalAgreement/service.ts',
        details: { originalError: error },
      }),
    );

    return;
  }
};

export const resolveAddLegalAgreementBatched = async (
  context: IContextParams,
  parametersList: TAddLegalAgreementRequest[],
): Promise<void> => {
  const promises = parametersList.map(parameters => resolveAddLegalAgreement(context, parameters));

  await Promise.all(promises);
};
